export default __webpack_public_path__ + "static/media/greyStepIncomplete.43ff4d90.svg";